

<p-card header="" class="p-md-12" id="import">
  <div class="p-grid">
    <div class="p-col p-field">
      <p-steps [model]="steps" [(activeIndex)]="activeIndex"></p-steps>
    </div>
  </div>
  <form #formDetails="ngForm">

    <div class="p-col " *ngIf="activeIndex==0" id="importStep1">
      <div class="p-grid">
        <div class="p-col-12 p-field">
          <label for="name">Nombre</label>
          <input name="name" type="text" pInputText [(ngModel)]="import.name" />
        </div>
        <div class="p-col p-field">

          <label for="name">Fichero</label>
          <label *ngIf="import.guid">
            <a (click)="downloadImport(import)"><fa-icon [icon]="['fas', 'download']"></fa-icon></a>
            {{import.filename}}
          </label>
  <p-fileUpload chooseLabel="Seleccione un fichero" [auto]="true"
                [showCancelButton]="!import.guid" [showUploadButton]="false" name="myfile[]" url="/api/import/upload" accept=".csv"
                (onError)="onErrorUpload($event)" (onUpload)="onBasicUpload($event)">

  </p-fileUpload>
  </div>
  <div class="p-col-12 p-field">
    <label for="entity_id">Importar </label>
    <p-dropdown name="entity_id"
                (onChange)="loadEntitiesFields()"
                [(ngModel)]="import.entity_id"
                [options]="entities" optionValue="id" optionLabel="name" placeholder="Selecciona una entidad"
                [disabled]="import.id"
                [showClear]="true" appendTo="body"></p-dropdown>
  </div>
  <div class="p-col-12">
    <p-accordion *ngIf="import.entity_id">
      <p-accordionTab [selected]="entity.entity.entity_id == import.entity_id" *ngFor="let entity of allowedEntities; let i = index">
        <p-header>
          <div class="">
            <p-checkbox [disabled]="entity.entity.entity_id == import.entity_id " inputId="showReportSection"
                        [(ngModel)]="entity.checked" [binary]="true"
                        name="showReportSection{{i}}"></p-checkbox>
            <label for="showReportSection" class="p-ml-2">{{entity.entity.entity_name}}</label>
          </div>
        </p-header>
        <div class="p-grid" *ngIf="!entity.checked"><small>Para poder configurar, por favor, seleccione la casilla</small></div>
        <div class="p-grid" *ngIf="entity.checked">

          <div class="p-col-12 col-md-3 p-field">
            <label for="import_mode">Modo de importación</label>
            <p-dropdown *ngIf="(entity.entity.entity_id != import.entity_id) && (!isTransactionLines || (isTransactionLines && entity.entity.alias=='transactionLine'))" appendTo="body" [options]="import_mode" [(ngModel)]="entity.mode" optionLabel="label" optionValue="code" name="import_mode{{i}}"></p-dropdown>
            <p-dropdown *ngIf="(entity.entity.entity_id == import.entity_id) && (!isTransactionLines || (isTransactionLines && entity.entity.alias=='transactionLine'))" appendTo="body" [options]="import_mode2" [(ngModel)]="entity.mode" optionLabel="label" optionValue="code" name="import_mode{{i}}"></p-dropdown>
            <p-dropdown *ngIf="isTransactionLines && entity.entity.alias!='transactionLine'" appendTo="body" [options]="import_mode_only_link" [(ngModel)]="entity.mode" optionLabel="label" optionValue="code" name="import_mode{{i}}"></p-dropdown>
          </div>

          <div class="p-col-12 col-md-3 p-field">
            <label for="identifications">Identificación de manera única</label>
            <p-dropdown [options]="entity.identifications"
                        [(ngModel)]="entity.type"
                        optionLabel="label"
                        optionValue="value"
                        appendTo="body"
                        name="identifications{{i}}"
                        (onChange)="identificationsChanged()"></p-dropdown>
          </div>

          <div class="p-col-12 col-md-3 p-field-checkbox" *ngIf="entity.entity.entity_id != import.entity_id">
            <p-checkbox [(ngModel)]="entity.ignore_null" binary="true" [ngModelOptions]="{standalone: true}" name="ignore_null{{i}}"></p-checkbox>
            <label for="ignore_null">Ignorar las columnas en blanco</label>
          </div>
        </div>
      </p-accordionTab>
    </p-accordion>
  </div>
  </div>
  </div>

  <div class="p-col p-field" *ngIf="activeIndex==1">
    <ng-template pTemplate="header">
      <div class="p-card-title">
        Mapeo de datos
      </div>
    </ng-template>
    <p-accordion *ngIf="import.entity_id">
      <p-accordionTab [selected]="entityAllowed.entity.entity_id == import.entity_id" *ngFor="let entityAllowed of allowedEntities; let i = index">
        <p-header>
          {{entityAllowed.entity.entity_name}}
          <small [ngStyle]="{color:'var(--green-600)'}">{{getEntityInfo(entityAllowed.entity.entity_id)}}</small>
        </p-header>
        <p-table styleClass="p-datatable-sm" [value]="getValueFilterBy(entityAllowed.entity.entity_id)" responsiveLayout="scroll" [lazy]="true">
          <ng-template pTemplate="header">
            <tr>
              <th>Propiedad</th>
              <th>Csv</th>
              <th>Tipo</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item>
            <tr>
              <td>{{item.description}} <small style="color:red" *ngIf="item.is_required || item.is_required_aux">&nbsp;Campo obligatorio</small></td>
              <td>
                <p-dropdown name="headersColumn" [ngModelOptions]="{standalone: true}"
                            [options]="headersColumn" optionValue="code" optionLabel="label" placeholder="No importar" [showClear]="true"
                            appendTo="body" [(ngModel)]="item.header" filter="true"></p-dropdown>
              </td>
              <td>
                <input *ngIf="showHideCustomOptions(item,'input-text')" [ngModelOptions]="{standalone: true}" type="text" pInputText [(ngModel)]="item.value" name="value" />
                <p-dropdown *ngIf="showHideCustomOptions(item,'input-dropdown')"
                            [(ngModel)]="item.value"
                            [options]="getOptionsData(item)"
                            placeholder="Seleccione" optionLabel="name" optionValue="id"
                            [showClear]="true" appendTo="body"
                            [ngModelOptions]="{standalone: true}"></p-dropdown>


                <p-multiSelect *ngIf="showHideCustomOptions(item,'dropdown-multiple')"
                               [options]="getOptionsData(item)"
                               [(ngModel)]="item.value"
                               optionLabel="name"
                               optionValue="id"
                               placeholder="Seleccione" [filter]="true"
                               [showClear]="true" appendTo="body" [ngModelOptions]="{standalone: true}"></p-multiSelect>
                <!--
  <p-dropdown *ngIf="showHideCustomOptions(item,'dropdown-multiple')"
                 [options]="getOptionsData(item)"
                 [(ngModel)]="item.value"
                 optionLabel="name"
                 optionValue="id"
                 placeholder="Seleccione" [filter]="true"
                 [showClear]="true" appendTo="body" [ngModelOptions]="{standalone: true}"></p-dropdown>

  -->



                <p-calendar *ngIf="showHideCustomOptions(item,'input-datetime')&&item.value_date=='date'" [(ngModel)]="item.value" name="value"
                            dateFormat="dd/mm/yy" hourFormat="24" [showIcon]="true" [showTime]="true"
                            appendTo="body" [ngModelOptions]="{standalone: true}" [stepMinute]="15"></p-calendar>
                <input *ngIf="showHideCustomOptions(item,'input-number')" [ngModelOptions]="{standalone: true}" [(ngModel)]="item.value" name="value"
                       type="number" pInputText />

                <p-checkbox *ngIf="showHideCustomOptions(item,'input-checkbox')" binary="true"
                            name="value"
                            [(ngModel)]="item.value"
                            [ngModelOptions]="{standalone: true}">
                </p-checkbox>
              </td>
            </tr>
          </ng-template>
        </p-table>


      </p-accordionTab>
    </p-accordion>

  </div>

  <div class="p-col p-field" *ngIf="activeIndex==2">
    <p-messages [(value)]="msgs_resume" [enableService]="false" [closable]="false"></p-messages>
    <p-messages [(value)]="msgs_resume_confirm" [enableService]="false" [closable]="false"></p-messages>
    <!--label *ngIf="msgs_resume_confirm" for="msgs_confirm">Confirmar importación</label>
    <p-checkbox name="msgs_confirm" [binary]="true" [(ngModel)]="confirm" *ngIf="msgs_resume_confirm"></p-checkbox-->
  </div>

  </form>
  <ng-template pTemplate="footer">
    <div class="p-d-flex">
      <button type="button" pButton icon="pi pi-angle-left" iconPos="left" label="Paso anterior" style="float: left;" (click)="prevStep()" *ngIf="activeIndex!=0"></button>
      <div class="flex-grow-1"></div>
      <button type="button" pButton icon="pi pi-angle-right" iconPos="right" label="Paso siguiente"
              [disabled]="!import.entity_id || !import.guid" style="float: right;" (click)="nextStep()"
              *ngIf="activeIndex!=2"></button>
      <button *ngIf="activeIndex==2" type="button" pButton icon="pi pi-save" [disabled]="disabledImportButton || (msgs_resume_confirm)" iconPos="right" style="float: right;" label="VALIDAR IMPORTACIÓN" (click)="save(false)"></button>
    </div>
  </ng-template>
</p-card>
<br>
